import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const settingsState = (state: AppState) => state.settings;

export const defaultCurrencySelector = createSelector(settingsState, settings => {
    return settings.currency;
});
